module.exports = __webpack_public_path__ + "img/399c0c6056925ca228c534402122f3d8.png";